import React, { useEffect, useState } from 'react';
import { Alert } from 'freemium-ui';
import { useFormContext } from 'react-hook-form';
import Spacer from 'components/Spacer';
import { HookFormEditable } from 'components/editable-input';
import { StyledActiveBadge } from './style';
import { validURL } from '../../../utils';
import { headerInputStyle, StyledLogo } from '../style';

export type SurveyHeaderProps = {
  imageRef: any;
  surveyForm: any;
};

export const SurveyHeader = ({ imageRef, surveyForm }: SurveyHeaderProps) => {
  const { watch } = useFormContext();
  // const [onSurveyInit, setOnSurveyInit] = useState(
  //   !surveyForm?.ui_branding?.logo_url,
  // );

  // useEffect(() => {
  //   if (surveyForm && onSurveyInit) {
  //     if (accountInfo?.logo_url && !surveyForm?.ui_branding?.logo_url)
  //       setValue('ui_branding.logo_url', accountInfo?.logo_url, {
  //         shouldValidate: true,
  //       });
  //     if (accountInfo?.favicon_url && !surveyForm?.ui_branding?.favicon_url)
  //       setValue('ui_branding.favicon_url', accountInfo?.favicon_url, {
  //         shouldValidate: true,
  //       });
  //     // wait for the form to update
  //     setTimeout(() => setOnSurveyInit(false));
  //   }
  // }, [accountInfo, surveyForm]);

  const isActive = surveyForm.state === 'ACTIVE';

  return (
    <>
      {isActive ? (
        <>
          <StyledActiveBadge className="status-banner">
            <br />
            <Alert canDismiss={false} level="warning">
              This survey is active and you need to pause this survey before
              editing it.
            </Alert>
          </StyledActiveBadge>
          <Spacer y={3} />
        </>
      ) : null}

      <div className="brand-logo" ref={imageRef}>
        {validURL(surveyForm?.ui_branding?.logo_url) ? (
          <img src={surveyForm.ui_branding.logo_url} alt="brand logo" />
        ) : (
          <StyledLogo>
            <div className="logoPlaceholder"> your logo </div>
            <div className="companyname">
              {watch('ui_branding.name') || 'Your logo or title goes here'}
            </div>
          </StyledLogo>
        )}
      </div>
      <div className="builder-header">
        <HookFormEditable
          type="textarea"
          disabled={isActive}
          overloadStyle={headerInputStyle}
          name={`header_message`}
          maxCount={300}
          defaultValue={surveyForm.header_message}
          placeholder="Enter tag line"
        />
      </div>
    </>
  );
};

export default SurveyHeader;
